import React, { useEffect, useState } from "react";
import styled from "styled-components";
import Slider from "react-slick";
import { config } from "../../config/config";
import { Link } from "react-router-dom";
import grooming from "../../assets/images/new/3.svg";
import vaccinations from "../../assets/images/new/2.svg";
import consulation from "../../assets/images/new/1.svg";
import { get } from "../../helpers/api_helpers";
import { useHistory } from "react-router";
import { getLocalStorage } from "../../helpers/utils";
import Login from "../../pages/Login";
import { useSelector } from "react-redux";

const Services = () => {
  const [services, setServices] = useState([]);
  const history = useHistory();
  const [modal, setModal] = useState(false);
  const [selectedService, setSelectedService] = useState(null);
  const [custError, setCustError] = useState("");
  // const loginState = useSelector((state) => state.Login);
  // const isLoggedIn = loginState?.user;

  useEffect(() => {
    let mounted = true;

    const fetchServices = async () => {
      try {
        const res = await get("/home");
        const list = res?.result?.services || [];
        console.log("checklist", list);
        if (mounted) {
          setServices(list.filter((b) => b.status));
        }
      } catch (err) {
        console.error(err);
      }
    };

    fetchServices();
    return () => {
      mounted = false;
    };
  }, []);

  const settings = {
    dots: true,
    arrows: true,
    infinite: services.length > 3, // ✅ prevent loop bugs
    speed: 500,
    autoplay: true,
    autoplaySpeed: 2500,
    pauseOnHover: true,
    slidesToShow: 4,
    slidesToScroll: 1, // ✅ smoother UX
    responsive: [
      {
        breakpoint: 992,
        settings: { slidesToShow: 2, slidesToScroll: 1 },
      },
      {
        breakpoint: 576,
        settings: { slidesToShow: 1, slidesToScroll: 1 },
      },
    ],
  };

  const isLoggedIn = getLocalStorage("AUTH_DETAILS");
  const handleServiceClick = (serviceId) => {
    if (!isLoggedIn) {
      setSelectedService(serviceId);
      setModal(true);
    } else {
      history.push("/clinic", {
        service_id: serviceId,
      });
    }
  };

  useEffect(() => {
    if (selectedService) {
      history.push("/clinic", {
        service_id: selectedService,
      });
      setSelectedService(null);
      setModal(false);
    }
  }, [selectedService]);

  if (!services.length) {
    return <p>Loading services...</p>;
  }

  return (
    <section className="">
      <div className="common-container pt-0">
        <div className="section-content">
          <Tittle className="text-left">
            <h2 className="">
              <span className="text-primary">SERVICES</span>
            </h2>
          </Tittle>
          <Slider {...settings}>
            {services.map((service, index) => (
              <div
                className="col-md-4 col-lg-4"
                key={service.id || index}
                onClick={() => handleServiceClick(service.id)}
              >
                <ServiceCard className="icon-box text-center mt-sm-0 servicesBg">
                  <img
                    className="ServicesIconImage"
                    src={service.icon}
                    alt={service.title}
                  />
                </ServiceCard>
                <h4 className="icon-box-title text-center text-capitalize letter-space-0">
                  <span className="darkTextColor segoeFont font-weight-bold f-22">
                    {service.title}
                  </span>
                </h4>
              </div>
            ))}
          </Slider>
        </div>
      </div>
      <Login
        modal_center={modal}
        setmodal_center={setModal}
        login_toggle={() => setModal(!modal)}
        pass={true}
        setCustError={setCustError}
        custError={custError}
      />
    </section>
  );
};

export default Services;

export const CustomImg = styled.div`
  width: 35%;
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  bottom: -20%;
  left: 2%;

  img {
    max-width: 100%;
  }

  @media only screen and (max-width: 900px) {
    width: 250px;
    bottom: -4%;
  }
`;
export const Tittle = styled.div`
  width: 100%;
  text-align: center;
  margin-bottom: 1rem;
  display: inline-block;

  h2 {
    font-size: 35px;
    color: #000;
    font-family: Montserrat;
    font-weight: normal;
    text-transform: capitalize;
    display: inline-block;
  }

  .tittleBold {
    color: #00419d;
    font-weight: bold;
  }

  .borderLine {
    border-bottom: 2px solid #07b1f1;
    padding-bottom: 10px;
    padding-right: 15px;
    padding-left: 15px;
  }

  @media only screen and (max-width: 900px) {
    margin-bottom: 2rem;

    h2 {
      font-size: 30px;
    }

    .tittleBold {
      margin-left: 10px;
    }
  }

  @media only screen and (max-width: 576px) {
  }
`;

export const CommonWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
`;

const IconWrapper = styled.div`
  display: flex;
  position: absolute;
  top: -7rem;
  left: 0;
  right: 0;
  align-items: center;
  justify-content: center;

  @media only screen and (max-width: 900px) {
    position: static;
  }
`;

const ServiceCard = styled.div`
  transition: all 0.3s ease;
  cursor: pointer;

  &:hover {
    transform: translateY(-10px);
    box-shadow: 0 10px 25px rgba(0, 0, 0, 0.15);
  }
`;
